
<div>
  <button class="btn btn-primary btn-sm" @click="toggleTimezone">
    Timezone: <span class="text-uppercase font-weight-bold">{{ user.timeZone }}</span><br>
  </button>
</div>
